import { useMemo } from 'react';

import { IFeedback, IFeedbackCounts, IFeedbackRequestParams } from 'models';
import { useFetchFeedbacksQuery } from 'store/apis/feedback.api';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { useAppSelector } from 'store/store.hook';

const EMPTY_COUNTS: IFeedbackCounts = { all: 0, ratings: 0, comments: 0 };

type UseFeedbacks = (params?: IFeedbackRequestParams) => [boolean, IFeedback[], IFeedbackCounts];

export const useFeedbacks: UseFeedbacks = (params = {}) => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);

  const { data, isFetching } = useFetchFeedbacksQuery({ orgSlug, params }, { skip: !orgSlug });

  return useMemo(() => {
    return [isFetching, data?.items ?? [], data?.counts ?? EMPTY_COUNTS];
  }, [isFetching, data]);
};
